<template>
    <oss-dialog
        v-if="!$vuetify.display.mobile"
        v-model="dialog"
        :title="
            $t('chat.createBTChatMessage.title', bankTransactions.length, {
                count: bankTransactions.length,
            })
        "
        min-width="1200px"
    >
        <v-list>
            <v-list-item border class="oss-list-item mb-2 rounded-xl px-4 py-3">
                <template v-slot:append>
                    <v-btn-next
                        :loading="createBankTransactionMessageLoading"
                        @click="createBankTransactionMessage()"
                    />
                </template>
                <v-list-item-title>Demande générale</v-list-item-title>
                <v-text-field-filled v-model="bankTransactionMessage" label="Message" single-line />
            </v-list-item>
            <v-list-item border class="oss-list-item mb-2 rounded-xl px-4 py-3">
                <template v-slot:append>
                    <v-btn-next
                        :loading="createBankTransactionInvoiceMessageLoading"
                        @click.stop="createBankTransactionMessage(true)"
                    />
                </template>
                <v-list-item-title>Demande de facture uniquement</v-list-item-title>
                <v-text-field-filled
                    v-model="bankTransactionInvoiceMessage"
                    label="Message"
                    single-line
                />
            </v-list-item>
        </v-list>
    </oss-dialog>
</template>

<script lang="ts">
import CREATE_BT_MESSAGE from "../../graphql/bankTransaction/CreateBankTransactionMessage.gql";
import { Component, Vue, toNative, Prop, Model } from "vue-facing-decorator";

@Component({
    emits: ["message-created"],
})
export class CreateBTChatMessage extends Vue {
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: [] }) bankTransactions: any;

    @Model({ name: "active" }) isActive: boolean;

    bankTransactionMessage = "Veuillez justifier ce mouvement bancaire";
    createBankTransactionMessageLoading = false;

    bankTransactionInvoiceMessage =
        "Pour ce montant, merci d'ajouter le justificatif correspondant";
    createBankTransactionInvoiceMessageLoading = false;

    get dialog() {
        return this.isActive;
    }

    set dialog(event: boolean) {
        this.isActive = event;
    }

    async createBankTransactionMessage(invoiceMessage = false) {
        if (invoiceMessage) {
            this.createBankTransactionInvoiceMessageLoading = true;
        } else {
            this.createBankTransactionMessageLoading = true;
        }

        if (this.bankTransactions.length && this.companyId) {
            await this.$apollo.mutate({
                mutation: CREATE_BT_MESSAGE,
                variables: {
                    companyId: this.companyId,
                    message: invoiceMessage
                        ? this.bankTransactionInvoiceMessage
                        : this.bankTransactionMessage,
                    ids: this.bankTransactions,
                },
            });
            this.$emit("message-created");
        }

        if (invoiceMessage) {
            this.createBankTransactionInvoiceMessageLoading = false;
        } else {
            this.createBankTransactionMessageLoading = false;
        }
        this.dialog = false;
    }
}

export default toNative(CreateBTChatMessage);
</script>
